export default __webpack_public_path__ + "static/media/3.b48f5f51.jpg";